module.exports = __webpack_public_path__ + "static/media/blueEdit.86026f91.svg";